import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useCart } from '../../hooks/useCart';
import { useCurrency } from '../../hooks/useCurrency';
import { useLanguage } from '../../hooks/useLanguage';
import { useState } from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import { getDisplayPrice, getSecondaryPrice } from '../../lib/currency';
import AntivirusComparison from './components/AntivirusComparison';
import AntivirusSeoJsonLd from './components/SeoJsonLd';

export default function AntivirusPage() {
  const { addItem } = useCart();
  const { currency } = useCurrency();
  const { t } = useLanguage();
  const [addedId, setAddedId] = useState<string | null>(null);
  const { containerRef, getAnimationClass, getAnimationStyle } = useScrollAnimation();

  const antivirusProducts = [
    {
      id: 'kasp-std-5',
      name: 'Kaspersky Standard 5 Dispositivos - 1 año',
      price: 229450,
      oldPrice: 550000,
      discount: '-58%',
      image: 'https://public.readdy.ai/ai/img_res/61527cc909a9d149bb0ac60b9009110f.jpg',
      badge: t('product.offer'),
      description: 'Protección esencial para 5 dispositivos durante 1 año.',
      type: '5 Dispositivos - 1 año',
      salesCount: 45,
    },
    {
      id: 'kasp-std-1',
      name: 'Kaspersky Standard 1 Dispositivo - 1 año',
      price: 115600,
      oldPrice: 195000,
      discount: '-41%',
      image: 'https://readdy.ai/api/search-image?query=kaspersky%20standard%20antivirus%20software%20box%20product%20packaging%20green%20theme%20clean%20white%20background%20studio%20lighting%20high%20quality%20product%20photography&width=250&height=250&seq=av2b&orientation=squarish',
      badge: t('product.offer'),
      description: 'Protección esencial para 1 dispositivo durante 1 año.',
      type: '1 Dispositivo - 1 año',
      salesCount: 29,
    },
    {
      id: 'kasp-prem-1',
      name: 'Kaspersky Premium 1 Dispositivo - 1 año',
      price: 173100,
      oldPrice: 275000,
      discount: '-37%',
      image: 'https://readdy.ai/api/search-image?query=kaspersky%20premium%20antivirus%20software%20box%20product%20packaging%20green%20theme%20clean%20white%20background%20studio%20lighting%20high%20quality%20product%20photography&width=250&height=250&seq=av2c&orientation=squarish',
      badge: t('product.offer'),
      highlightBadge: 'Premium',
      description: 'Protección premium completa para 1 dispositivo.',
      type: '1 Dispositivo - 1 año',
      salesCount: 62,
    },
    {
      id: 'kasp-prem-5',
      name: 'Kaspersky Premium 5 Dispositivos - 1 año',
      price: 305200,
      oldPrice: 630000,
      discount: '-52%',
      image: 'https://readdy.ai/api/search-image?query=kaspersky%20premium%20antivirus%20software%20box%20product%20packaging%20green%20theme%20clean%20white%20background%20studio%20lighting%20high%20quality%20product%20photography&width=250&height=250&seq=av2d&orientation=squarish',
      badge: t('product.offer'),
      highlightBadge: 'Más Vendido',
      description: 'Protección premium completa para 5 dispositivos.',
      type: '5 Dispositivos - 1 año',
      salesCount: 280,
    },
    {
      id: 'kasp-plus-1-2y',
      name: 'Kaspersky Plus 1 Dispositivo - 2 años',
      price: 143750,
      oldPrice: 275000,
      discount: '-48%',
      image: 'https://readdy.ai/api/search-image?query=kaspersky%20plus%20antivirus%20software%20box%20product%20packaging%20green%20theme%20clean%20white%20background%20studio%20lighting%20high%20quality%20product%20photography&width=250&height=250&seq=av3a&orientation=squarish',
      badge: t('product.offer'),
      description: 'Protección avanzada para 1 dispositivo durante 2 años.',
      type: '1 Dispositivo - 2 años',
      salesCount: 67,
    },
    {
      id: 'kasp-plus-5-2y',
      name: 'Kaspersky Plus 5 Dispositivos - 2 años',
      price: 264900,
      oldPrice: 630000,
      discount: '-58%',
      image: 'https://readdy.ai/api/search-image?query=kaspersky%20plus%20antivirus%20software%20box%20product%20packaging%20green%20theme%20clean%20white%20background%20studio%20lighting%20high%20quality%20product%20photography&width=250&height=250&seq=av3b&orientation=squarish',
      badge: t('product.offer'),
      highlightBadge: 'Mejor Valor',
      description: 'Protección avanzada para 5 dispositivos durante 2 años.',
      type: '5 Dispositivos - 2 años',
      salesCount: 73,
    },
    {
      id: 'mcafee-1',
      name: 'McAfee Total Protection 1 Dispositivo - 1 año',
      price: 97750,
      oldPrice: 180000,
      discount: '-46%',
      image: 'https://readdy.ai/api/search-image?query=mcafee%20total%20protection%20antivirus%20software%20box%20product%20packaging%20red%20theme%20clean%20white%20background%20studio%20lighting%20high%20quality%20product%20photography&width=250&height=250&seq=av5&orientation=squarish',
      badge: t('product.offer'),
      highlightBadge: 'Mejor Precio',
      description: 'Protección total McAfee para 1 dispositivo.',
      type: '1 Dispositivo - 1 año',
      salesCount: 56,
    },
    {
      id: 'mcafee-5',
      name: 'McAfee Total Protection 5 Dispositivos - 1 año',
      price: 281750,
      oldPrice: 530530,
      discount: '-47%',
      image: 'https://readdy.ai/api/search-image?query=mcafee%20total%20protection%20antivirus%20software%20box%20product%20packaging%20red%20theme%20clean%20white%20background%20studio%20lighting%20high%20quality%20product%20photography&width=250&height=250&seq=av5b&orientation=squarish',
      badge: t('product.offer'),
      description: 'Protección total McAfee para 5 dispositivos.',
      type: '5 Dispositivos - 1 año',
      salesCount: 121,
    },
    {
      id: 'eset-1-2y',
      name: 'ESET NOD32 Antivirus 1 Dispositivo - 2 años',
      price: 109250,
      oldPrice: 230650,
      discount: '-53%',
      image: 'https://readdy.ai/api/search-image?query=eset%20nod32%20antivirus%20software%20box%20product%20packaging%20orange%20teal%20theme%20clean%20white%20background%20studio%20lighting%20high%20quality%20product%20photography&width=250&height=250&seq=av6&orientation=squarish',
      badge: t('product.offer'),
      description: 'Antivirus ESET NOD32 para 1 dispositivo durante 2 años.',
      type: '1 Dispositivo - 2 años',
      salesCount: 45,
    },
    {
      id: 'eset-5-2y',
      name: 'ESET NOD32 Antivirus 5 Dispositivos - 2 años',
      price: 339250,
      oldPrice: 560530,
      discount: '-39%',
      image: 'https://readdy.ai/api/search-image?query=eset%20nod32%20antivirus%20software%20box%20product%20packaging%20orange%20teal%20theme%20clean%20white%20background%20studio%20lighting%20high%20quality%20product%20photography&width=250&height=250&seq=av6b&orientation=squarish',
      badge: t('product.offer'),
      highlightBadge: 'Popular',
      description: 'Antivirus ESET NOD32 para 5 dispositivos durante 2 años.',
      type: '5 Dispositivos - 2 años',
      salesCount: 204,
    },
  ];

  const handleAddToCart = (product: typeof antivirusProducts[0]) => {
    try {
      addItem({
        id: product.id,
        name: product.name,
        type: product.type,
        price: product.price,
        oldPrice: product.oldPrice,
        image: product.image,
      });
      setAddedId(product.id);
      setTimeout(() => setAddedId(null), 1500);
    } catch (error) {
      console.error('Error adding product to cart:', error);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <AntivirusSeoJsonLd />
      <Header />

      {/* Hero */}
      <section className="relative h-[200px] sm:h-[300px] bg-gradient-to-r from-green-600 to-teal-500 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=cybersecurity%20digital%20shield%20protection%20concept%20with%20glowing%20green%20teal%20holographic%20interface%20futuristic%20antivirus%20security%20technology%20abstract%20network%20defense%20system%20clean%20modern%20background%20with%20floating%20security%20icons%20lock%20symbols%20data%20encryption%20visualization&width=1920&height=300&seq=antivirushero02&orientation=landscape"
            alt="Antivirus Security"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-green-600/80 via-teal-500/70 to-green-600/80"></div>
        </div>
        <div className="relative container mx-auto px-4 h-full flex items-center">
          <div className="text-white">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-2 sm:mb-4">{t('antivirus.title')}</h1>
            <p className="text-sm sm:text-lg md:text-xl max-w-2xl leading-relaxed">
              {t('antivirus.subtitle')}
            </p>
          </div>
        </div>
      </section>

      {/* Comparison Table */}
      <AntivirusComparison />

      {/* Products */}
      <main className="flex-1 py-8 sm:py-16">
        <div className="container mx-auto px-4">
          <div ref={containerRef} className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6" data-product-shop>
            {antivirusProducts.map((product, index) => {
              const display = getDisplayPrice(product.price, product.oldPrice, currency);
              const secondary = getSecondaryPrice(product.price, product.oldPrice, currency);
              return (
                <div
                  key={product.id}
                  data-anim-index={index}
                  style={getAnimationStyle(index)}
                  className={`bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-all duration-500 ease-out group cursor-pointer ${getAnimationClass(index)}`}
                >
                  <div className="relative">
                    {product.highlightBadge && product.highlightBadge.trim() !== '' ? (
                      <span className={`absolute top-2 left-2 sm:top-3 sm:left-3 text-white text-[10px] sm:text-xs font-semibold px-1.5 py-0.5 sm:px-2 sm:py-1 rounded whitespace-nowrap z-10 ${
                        product.highlightBadge === 'Más Vendido' ? 'bg-orange-500' :
                        product.highlightBadge === 'Mejor Precio' ? 'bg-emerald-500' :
                        product.highlightBadge === 'Premium' ? 'bg-amber-500' :
                        product.highlightBadge === 'Mejor Valor' ? 'bg-teal-500' :
                        product.highlightBadge === 'Popular' ? 'bg-indigo-500' :
                        'bg-red-500'
                      }`}>
                        <i className={`mr-0.5 sm:mr-1 ${
                          product.highlightBadge === 'Más Vendido' ? 'ri-fire-fill' :
                          product.highlightBadge === 'Mejor Precio' ? 'ri-price-tag-3-fill' :
                          product.highlightBadge === 'Premium' ? 'ri-vip-crown-fill' :
                          product.highlightBadge === 'Mejor Valor' ? 'ri-thumb-up-fill' :
                          product.highlightBadge === 'Popular' ? 'ri-heart-fill' :
                          ''
                        }`}></i>
                        {product.highlightBadge}
                      </span>
                    ) : (
                      <span className="absolute top-2 left-2 sm:top-3 sm:left-3 bg-red-500 text-white text-[10px] sm:text-xs font-semibold px-1.5 py-0.5 sm:px-2 sm:py-1 rounded whitespace-nowrap">
                        {product.badge}
                      </span>
                    )}
                    {product.discount && (
                      <span className="absolute top-2 right-2 sm:top-3 sm:right-3 bg-red-500 text-white text-[10px] sm:text-xs font-semibold px-1.5 py-0.5 sm:px-2 sm:py-1 rounded whitespace-nowrap">
                        {product.discount}
                      </span>
                    )}
                    <div className="w-full h-32 sm:h-48 bg-gray-50 flex items-center justify-center p-3 sm:p-4">
                      <img
                        src={product.image}
                        alt={product.name}
                        className="w-full h-full object-contain group-hover:scale-105 transition-transform"
                      />
                    </div>
                  </div>
                  <div className="p-3 sm:p-4">
                    <h3 className="text-xs sm:text-sm font-medium text-gray-900 mb-1 sm:mb-2 line-clamp-2 min-h-[32px] sm:h-10">{product.name}</h3>
                    <p className="text-[10px] sm:text-xs text-gray-600 mb-2 sm:mb-3 line-clamp-2 hidden sm:block">{product.description}</p>
                    <div className="flex items-center gap-1 mb-2 sm:mb-3">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-400 text-[10px] sm:text-sm"></i>
                      ))}
                      <span className="text-[9px] sm:text-xs text-gray-500 ml-0.5">(5.0)</span>
                    </div>
                    <div className="flex items-center gap-1 mb-1.5 sm:mb-2">
                      <i className="ri-shopping-bag-line text-[10px] sm:text-xs text-orange-500"></i>
                      <span className="text-[10px] sm:text-xs text-gray-500">{product.salesCount.toLocaleString('es-CO')} vendidos</span>
                    </div>
                    <div className="flex flex-col sm:flex-row sm:items-center gap-0.5 sm:gap-2">
                      <span className="text-base sm:text-lg font-bold text-gray-900">{display.main}</span>
                      {display.oldMain && (
                        <span className="text-[10px] sm:text-sm text-gray-500 line-through">{display.oldMain}</span>
                      )}
                    </div>
                    <div className="flex items-center gap-1 sm:gap-2 mt-0.5">
                      <p className="text-[10px] sm:text-xs text-emerald-600 font-medium">
                        ≈ {secondary.current}
                      </p>
                      {secondary.old && (
                        <p className="text-[10px] sm:text-xs text-gray-400 line-through hidden sm:block">
                          {secondary.old}
                        </p>
                      )}
                    </div>
                    <button
                      onClick={() => handleAddToCart(product)}
                      className={`w-full mt-3 sm:mt-4 py-2 rounded-lg font-medium text-xs sm:text-sm transition-colors cursor-pointer whitespace-nowrap ${
                        addedId === product.id
                          ? 'bg-green-500 text-white'
                          : 'bg-[#0078D4] text-white hover:bg-[#006abc]'
                      }`}
                    >
                      {addedId === product.id ? (
                        <>
                          <i className="ri-check-line mr-1"></i>
                          {t('product.added')}
                        </>
                      ) : (
                        <>
                          <i className="ri-shopping-cart-line mr-1 sm:hidden"></i>
                          <span className="hidden sm:inline">{t('product.add_to_cart')}</span>
                          <span className="sm:hidden">{t('product.add')}</span>
                        </>
                      )}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
